module.exports = __webpack_public_path__ + "static/img/longxia.719e43b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/longxia.png
// module id = 87
// module chunks = 0